import serverURL from "api/auth/auth";

/**
 * Base URL of the FMS rental-agreement PDF viewer (`/pdf?agreement=`) for the
 * current environment, derived from the API host (`serverURL`).
 *
 * Why not `process.env.REACT_APP_ENV`? The previous per-call switch only
 * handled "dev"/"stage" and fell through to the prod host for everything else.
 * The QA build does not set a "qa" env value, so on QA the agreement iframe
 * loaded prod's `/pdf` — which cannot resolve the QA booking/company and
 * bounces the user to the 1NOW sign-in page (1NOW-1239). `serverURL` is pinned
 * correctly per branch (QA -> api-qa-fleet-management), so it is the reliable
 * signal for the matching FMS host.
 *
 * These are the `1now.ai` hosts, not `1now.app`. The `.app` names still answer,
 * but only as a 301 to the matching `.ai` one, and on dev that redirect rule
 * drops the path: `dev.1now.app/pdf?agreement=<id>` arrives as
 * `dev.1now.ai/?agreement=<id>`, which is the dashboard's home page rather than
 * the agreement. qa, stage and prod preserve the path today, so this was a
 * dev-only break, but pointing at the real host removes the dependency on a
 * redirect rule none of this code controls. Prod is `app.1now.ai`: bare
 * `1now.ai` 404s on /pdf.
 */
export const getAgreementPdfBase = (): string => {
  const api = serverURL ?? "";
  if (api.includes("api-qa")) return "https://qa.1now.ai/pdf?agreement=";
  if (api.includes("api-stage")) return "https://stage.1now.ai/pdf?agreement=";
  if (api.includes("fleet-management-dev"))
    return "https://dev.1now.ai/pdf?agreement=";
  return "https://app.1now.ai/pdf?agreement=";
};
